<template>
  <div class="login-block">
    <div class="login-title" @click="$emit('update', 'loginP')">
      <h5>协议更新</h5>
    </div>
    <div class="privacy-notice">
      <p>
        &emsp;&emsp;感谢您信任并使用VBIM平台！我们依据最新的法律法规及监管政策要求，更新了
        <router-link to="/privacy" class="link primary" target="_blank">《VBIM平台隐私政策》</router-link>与
        <router-link to="/service" class="link primary" target="_blank">《VBIM平台服务协议》</router-link>。
      </p>
      <p>&emsp;&emsp;请您务必仔细阅读并透彻理解相关条款内容，在确认充分理解并同意后使用VBIM平台相关产品或服务。</p>
    </div>

    <div class="btn-box">
      <v-button @click="doAgree" :loading="loading">知悉并同意</v-button>
    </div>
  </div>
</template>

<script>
import aes from "@/uitls/aes";
import { setCookie } from "@/uitls/index";
import vButton from "./vButton.vue";

import mixinRedirect from "../utils/mixinRedirect";

export default {
  components: {
    vButton
  },
  mixins: [mixinRedirect],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    // TODO: need clean saved token when give up agreement
    /* enable loading on v-button */
    doLoading() {
      this.loading = true;
    },
    /* close loading on v-button */
    doCloseLoading() {
      this.loading = false;
    },
    /* agree privacy */
    doAgree() {
      this.doLoading();
      this.$http
        .post(
          "/user-server/agreement/add",
          {
            version: process.env.PRIVACY_VER
            // TODO: aes.Encrypt(process.env.PRIVACY_VER)
          },
          {
            headers: {
              Authorization: this.$store.state.index.dataTokn
            },
            interceptorDisabled: true
          }
        )
        .then(({ data: { code, message } }) => {
          this.doCloseLoading();
          if (code == 200) {
            this.doSetCookie();
            this.doRedirect();
          } else {
            this.$message.error(message);
          }
        })
        .catch(err => {
          this.doCloseLoading();
          console.log("ERROR", err);
        });
    },
    /* set token into cookie */
    doSetCookie() {
      setCookie("accesstoken", this.$store.state.index.dataTokn, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../styles/login.scss";
$text-active-color: #0081ff;

.link {
  height: 22px;
  line-height: 22px;
  font-size: 16px;
  color: #666;
  box-sizing: border-box;
  border-bottom: solid 1px transparent;
  transition: border-color 0.12s ease-out;
  cursor: default;

  &:hover {
    border-color: #666;
  }

  &.primary {
    color: $text-active-color;

    &:hover {
      border-color: $text-active-color;
    }
  }
}
.privacy-notice {
  word-break: break-word;
  line-height: 24px;
  font-size: 16px;
  text-align: justify;
  padding-top: 20px;
  padding-bottom: 20px;

  p {
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/privacyA.vue